<div class="main-container">
  <div class="login-container">
    @if (isLoggedIn || loader) {
      <div class="loader"></div>
    }
    <div class="login-header"></div>
    <form class="login-form flex-col" #form="ngForm" name="loginForm"
      [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit(loginForm.value)">
      <div class="input-container">
        <label for="email" class="">{{'email' | translate}}</label>
        <input type="text" id="email" name="email" formControlName="email" class="form-field">
      </div>
      @if (email.invalid && email.touched) {
        <div class="control-error-container">
          @if (email.errors?.required) {
            <span>{{'required_field' | translate}}</span>
          }
          @if (email.errors?.pattern) {
            <span>{{'invalid_email' | translate}}</span>
          }
        </div>
      }
      <div class="input-container">
        <label for="password" class="">{{'password' | translate}}</label>
        <input type="password" id="password" name="password" formControlName="password" class="form-field">
      </div>
      @if (password.invalid && password.touched) {
        <div class="control-error-container">
          @if (password.errors?.required) {
            <span>{{'required_field' | translate}}</span>
          }
          @if (password.errors?.minlength) {
            <span>{{'pass_min_length' | translate}}</span>
          }
          @if (password.errors?.maxlength) {
            <span>{{'pass_max_length' | translate}}</span>
          }
        </div>
      }

      <div class="button-container">
        <button type="submit" class="submit-btn login-btn" #loginButton [ngClass]="{'disabled': loginForm.invalid}">{{'login' | translate}}</button>
      </div>

      <div class="helper">
        <div class="forgot-password-link options-block flex-row">
          <a routerLink="/forgot-password" (click)="forgotPassword()">{{'forgot_password' | translate}}?</a>
        </div>
        <div class="flag-container">
          <language-dropdown></language-dropdown>
        </div>
      </div>
      <br> <br> <br> <br>
      <div>
        <!-- <div class="okta-button-container">
        <div >Sign in with</div>
        <br>
          <div>
            <button id="oktaLoginButton" type="button" class="submit-btn login-btn okta-login-btn" (click)="oktaLogin()"> Diversey SSO (Okta)</button>
          </div>
        </div> -->

      </div>
    </form>
  </div>

  <!-- <div class="okta-login-container">
  <div class=" login-form okta-button-container">
    <div >Sign in with</div>
    <br>
      <div>
        <button id="oktaLoginButton" type="button" class="submit-btn login-btn" (click)="oktaLogin()"> Diversey SSO(Okta)</button>
      </div>
    </div>
  </div> -->

</div>
